<template>
    <div class="slider-container" data-aos="fade-in">

        <carousel :perPage="1" :navigationEnabled="true" :paginationEnabled="true" :autoplay="true" :autoplayTimeout="4000" :autoplayHoverPause="true" :loop="true">
            <slide v-for="(slide, i) in slides" :key="i">
                <div class="slide" :style="backgroundStyle(slide)">

                    <div class="container flex items-center h-full px-2">

                        <div class="slide-content text-white">

                            <div data-aos="fade-up">
                                <h2 class="text-7 font-400 leading-none capitalize">{{ slide.slider_title }}</h2>
                            </div>

                            <div class="bg-pink w-hr h-hr my-3" data-aos="fade-up"></div>

                            <div class="leading-tight text-3 font-300" v-html="slide.slider_body" data-aos="fade-up" data-aos-delay="50"></div>

                            <div class="mt-4" v-if="slide.slider_link" data-aos="fade-up" data-aos-delay="100">
                                <a class="slider-button text-white bg-pink rounded-full text-3 hover:bg-blue hover:text-white" :href="slide.slider_link">
                                    {{ slide.slider_link_text }}
                                </a>
                            </div>

                        </div>

                    </div>

                </div>
            </slide>
        </carousel>

    </div>
</template>

<script>
    // Import the entire module instead of destructuring
import VueCarousel from 'vue-carousel';

    export default {

        name: 'LaserSlider',

        components: {
            'carousel': VueCarousel.Carousel,
            'slide': VueCarousel.Slide,
        },

        props: {
            slides: {
                type: Array,
                default() {
                    return [];
                },
            },
        },

        methods: {

            backgroundStyle(slide) {
                return `background-image: url(${slide.slider_image}); color: ${slide.slide_colour}`;
            },

        },

    }
</script>

<style scoped lang="scss">

    .slider-container {
        overflow: hidden;
        box-shadow: inset 0px 5px 28px -8px rgba(0, 0, 0, .4);
    }

    .slide {
        position: relative;
        z-index: 1;
        min-height: 500px;
        overflow: hidden;
        background-size: cover;
        background-position: top right;
        background-repeat: no-repeat;

        &::before {
            pointer-events: none;
            position: absolute;
            left: 0;
            top: 0;
            z-index: -1;
            content: '';
            height: 100%;
            width: 100%;
            background: currentColor;
            opacity: .8;

            @media (min-width: 767px) {
                width: 50%;
            }

            @media (min-width: 992px) {
                transform: translateX(-200px);
            }
        }

        &::after {
            pointer-events: none;
            position: absolute;
            left: 50%;
            top: 0;
            z-index: -1;
            content: '';
            height: 100%;
            width: 200px;
            background-image: linear-gradient(to top right, currentColor 0, currentColor 50%,transparent 0,transparent);
            opacity: .8;

            @media (max-width: 767px) {
                display: none;
            }

            @media (min-width: 992px) {
                transform: translateX(-200px);
            }
        }
    }

    .slide-content {
        padding: 100px 0 50px;

        p + p {
            margin-top: 20px;
        }

        @media (min-width: 767px) {
            width: calc(50% - 150px);
        }
    }

    .slider-button {
        padding: 5px 30px;
    }

    .VueCarousel-pagination {
        position: absolute;
        bottom: 0;
    }
</style>

<style lang="scss">
    .VueCarousel-pagination {
        position: absolute;
        bottom: 0;
    }

    .VueCarousel-navigation-button {
        &.VueCarousel-navigation-prev {
            left: 35px;
        }

        &.VueCarousel-navigation-next {
            right: 35px;
        }
    }

</style>



// WEBPACK FOOTER //
// web/app/themes/giles/resources/js/components/LaserSlider.vue